import { isFunction } from "@thi.ng/checks/is-function";
import { CloseMode, } from "./api.js";
import { __optsWithID } from "./idgen.js";
import { LOGGER } from "./logger.js";
import { Subscription } from "./subscription.js";
export function stream(src, opts) {
    return new Stream(src, opts);
}
/**
 * Syntax sugar for {@link stream}. Creates new stream which is
 * immediately seeded with initial `val` and configured with optional
 * `opts`.
 *
 * @param val -
 * @param opts -
 */
export const reactive = (val, opts) => {
    const res = new Stream(opts);
    res.next(val);
    return res;
};
/**
 * @see {@link stream} & {@link reactive} for reference & examples.
 */
export class Stream extends Subscription {
    constructor(src, opts) {
        const [_src, _opts] = isFunction(src)
            ? [src, opts || {}]
            : [undefined, src || {}];
        super(_opts.error ? { error: _opts.error } : undefined, __optsWithID("stream", _opts));
        this.src = _src;
        this._inited = false;
    }
    subscribe(sub, opts = {}) {
        const $sub = super.subscribe(sub, opts);
        if (!this._inited) {
            if (this.src) {
                try {
                    this._cancel = this.src(this) || (() => void 0);
                }
                catch (e) {
                    let s = this.wrapped;
                    if (!s || !s.error || !s.error(e)) {
                        this.unhandledError(e);
                    }
                }
            }
            this._inited = true;
        }
        return $sub;
    }
    unsubscribe(sub) {
        const res = super.unsubscribe(sub);
        if (res &&
            (!sub ||
                ((!this.subs || !this.subs.length) &&
                    this.closeOut !== CloseMode.NEVER))) {
            this.cancel();
        }
        return res;
    }
    done() {
        this.cancel();
        super.done();
        delete this.src;
        delete this._cancel;
    }
    error(e) {
        if (super.error(e))
            return true;
        this.cancel();
        return false;
    }
    cancel() {
        if (this._cancel) {
            LOGGER.debug(this.id, "cancel");
            const f = this._cancel;
            delete this._cancel;
            f();
        }
    }
}
